import { computed, Injectable, signal } from '@angular/core';
import { DialogEventTabs } from '@app/main/leak-detection/dialogs/dialog-event/enums/dialog-event-tabs.enum';
import { DialogEventOverlay } from '@app/main/leak-detection/dialogs/dialog-event/enums/dialog-event-overlay.enum';
import { DialogEventEditor } from '@app/main/leak-detection/dialogs/dialog-event/enums/dialog-event-editor.enum';
import { DialogEventStatusAction } from '@app/main/leak-detection/dialogs/dialog-event/enums/dialog-event-status-action.enum';

// event popup tabs logic
@Injectable()
export class DialogEventTabsService {
  public readonly activeTab = signal<DialogEventTabs>(DialogEventTabs.Details);

  public readonly overlay = signal<DialogEventOverlay | null>(null);

  public readonly editor = signal<DialogEventEditor | null>(null);

  /** the change the `Status` editor asks about — set together with it by `openStatusChange` */
  public readonly statusAction = signal<DialogEventStatusAction | null>(null);

  public readonly isEditing = computed(() => !!this.editor());

  public openEditor(editor: DialogEventEditor.Location | DialogEventEditor.Result): void {
    this.editor.set(editor);
  }

  public openStatusChange(action: DialogEventStatusAction): void {
    this.statusAction.set(action);
    this.editor.set(DialogEventEditor.Status);
  }

  public closeEditor(): void {
    this.editor.set(null);
    this.statusAction.set(null);
  }

  public openOverlay(overlay: DialogEventOverlay): void {
    this.overlay.set(overlay);
  }

  public closeOverlay(): void {
    this.overlay.set(null);
  }
}
